import type { Translations } from '../../types'

const customersMessages: Translations = {
  "customers.header.eyebrow": "Clienti",
  "customers.header.title": "Clienti",
  "customers.header.subtitle": "Consulta i clienti, apri il profilo e visualizza rapidamente i loro ordini.",
  "customers.auth.title": "Sessione non disponibile",
  "customers.auth.subtitle": "Effettua il login per consultare anagrafica e storico ordini clienti.",
  "customers.auth.missingToken": "Token amministratore mancante.",
  "customers.filters.panelTitle": "Filtri",
  "customers.filters.show": "Mostra filtri",
  "customers.filters.hide": "Nascondi filtri",
  "customers.filters.search": "Ricerca cliente",
  "customers.filters.searchPlaceholder": "Nome, username, email",
  "customers.filters.limit": "Risultati per pagina",
  "customers.filters.actions": "Azioni",
  "customers.actions.apply": "Applica",
  "customers.actions.reset": "Reset",
  "customers.actions.backToList": "Torna alla lista clienti",
  "customers.actions.prev": "Precedente",
  "customers.actions.next": "Successiva",
  "customers.list.panelTitle": "Clienti",
  "customers.list.loading": "Caricamento clienti...",
  "customers.list.total": "{{count}} clienti totali",
  "customers.list.page": "Pagina {{page}} / {{totalPages}}",
  "customers.list.results": "clienti",
  "customers.list.emptyTitle": "Nessun cliente trovato",
  "customers.list.empty": "Nessun cliente trovato con i filtri correnti.",
  "customers.list.openProfile": "Apri profilo",
  "customers.list.columns.customer": "Cliente",
  "customers.list.columns.email": "Email",
  "customers.list.columns.lastLogin": "Ultimo accesso",
  "customers.details.title": "Dettaglio cliente",
  "customers.details.loading": "Caricamento dettaglio...",
  "customers.details.notFound": "Cliente non trovato: {{customerId}}",
  "customers.details.selectPrompt": "Seleziona un cliente dalla tabella.",
  "customers.details.hero.memberSince": "Cliente dal",
  "customers.details.hero.lastAccess": "Ultimo accesso",
  "customers.details.hero.orders": "Numero ordini",
  "customers.details.hero.totalSpent": "Spesa totale",
  "customers.details.fields.name": "Nome:",
  "customers.details.fields.username": "Username:",
  "customers.details.fields.email": "Email:",
  "customers.details.fields.createdAt": "Creato il:",
  "customers.details.fields.lastLogin": "Ultimo accesso:",
  "customers.orders.title": "Storico ordini cliente",
  "customers.orders.subtitle": "Apri un ordine per consultare tracking, fatture e operazioni disponibili.",
  "customers.orders.status": "Stato ordini",
  "customers.status.all": "Tutti",
  "customers.status.created": "Creato",
  "customers.status.paid": "Pagato",
  "customers.status.shipped": "Spedito",
  "customers.status.cancelled": "Annullato",
  "customers.status.active": "Attivo",
  "customers.status.deleted": "Eliminato",
  "customers.orders.loading": "Caricamento ordini cliente...",
  "customers.orders.empty": "Nessun ordine associato a questo cliente.",
  "customers.orders.columns.order": "Ordine",
  "customers.orders.columns.createdAt": "Data creazione",
  "customers.orders.columns.status": "Stato",
  "customers.orders.columns.total": "Totale",
  "customers.orders.columns.actions": "Azioni",
  "customers.orders.createdAt": "Creato: {{date}}",
  "customers.orders.showDetails": "Apri dettaglio",
  "customers.orders.hideDetails": "Nascondi dettagli",
  "customers.orders.openOrder": "Apri ordine",
  "customers.orders.itemsEmpty": "Nessuna riga prodotto.",
  "customers.orders.itemSummary": "Qta: {{quantity}} • Totale riga: {{lineTotal}}",
  "customers.orders.activeOrder": "Ordine attivo: {{orderNumber}}. Resti nella vista cliente mentre consulti il dettaglio.",
  "customers.messages.loadCustomersError": "Errore caricamento clienti",
  "customers.messages.loadCustomerDetailError": "Errore caricamento dettaglio cliente",
  "customers.messages.loadCustomerOrdersError": "Errore caricamento ordini cliente",
  "customers.empty.all.title": "Nessun cliente trovato",
  "customers.empty.all.subtitle": "Modifica i filtri o la ricerca per trovare un cliente.",
  "customers.empty.active.title": "Nessun cliente attivo",
  "customers.empty.active.subtitle": "Non ci sono clienti attivi che corrispondono ai filtri correnti.",
  "customers.empty.deleted.title": "Nessun cliente eliminato",
  "customers.empty.deleted.subtitle": "Non ci sono clienti che hanno richiesto la cancellazione dell’account."
}

export default customersMessages
